import { createContext, useCallback, useContext, useMemo, useState } from "react";
import useNotificationSubscription from "./useNotificationSubscription";

export const NotificationContext = createContext({
  hasUnreadNotifications: false,
  unreadCount: 0,
  markNotificationsSeen: () => { },
  setUnreadFromCount: () => { },
  tenantId: null,
});

const NotificationProvider = ({
  children,
  tenantId,
  shouldStartSubscription,
}) => {
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const handleNotificationReceived = useCallback((notification) => {
    if (!notification?.is_read) {
      setHasUnreadNotifications(true);
      setUnreadCount((prev) => prev + 1);
    }
  }, []);

  const markNotificationsSeen = useCallback(() => {
    setHasUnreadNotifications(false);
    setUnreadCount(0);
  }, []);

  const setUnreadFromCount = useCallback((count) => {
    const numCount = Number(count) || 0;
    setHasUnreadNotifications(Boolean(numCount > 0));
    setUnreadCount(numCount);
  }, []);

  useNotificationSubscription({
    tenantId,
    enabled: shouldStartSubscription,
    onNotification: handleNotificationReceived,
  });

  const value = useMemo(
    () => ({
      hasUnreadNotifications,
      unreadCount,
      markNotificationsSeen,
      setUnreadFromCount,
      tenantId,
    }),
    [hasUnreadNotifications, unreadCount, markNotificationsSeen, setUnreadFromCount, tenantId]
  );

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationCenter = () => useContext(NotificationContext);

export default NotificationProvider;
